import { asyncLoad } from '@util'

export default {
  path: 'myCoupon',
  indexRoute: {
    component: asyncLoad(() => import('@components/LocalMerchant/MyCoupon'))
  },
  stat: '优惠卡券'
  /*  childRoutes: [
      {
        path: 'detail',
        component: asyncLoad(() =>
          import('@components/LocalMerchant/PurchaseHistory/PaymentDetail')
        ),
        stat: '购买记录/订单详情'
      }
    ]*/
}
